<template>
  <section>
    <h2> {{calc == 'eqn' ? '連立方程式' : '行列'}}の入力 </h2>
    <h3> {{calc == 'eqn' ? 'データ' : 'サイズ'}} </h3>
    <p v-if="calc == 'reduce'">
      <input type="text" :class="{error: rows_error}" v-model.number="rows_i" />行
      × <input type="text" :class="{error: cols_error}" v-model.number="cols_i" />列
    </p>
    <ul v-if="calc == 'eqn'">
      <li> 等式の個数 : <input type="text" :class="{error: rows_error}" v-model.number="rows_i" /> 個 </li>
      <li> 未知数の個数 : <input type="text" :class="{error: cols_error}" v-model.number="cols_i" /> 個 </li>
      <li> 未知数の名前
	<ul>
	  <li>
	    <label for="char"><input type="radio" v-model="config.type" value="char" id="char" /> アルファベット順、
	      最初の未知数 : <input type="text" @change="config.type = 'char'" v-model="config.character"
				    :class="{error: config.error}" /></label>	    
	  </li>
	  <li>
	    <label for="index"><input type="radio" v-model="config.type" value="index" id="index" />
	      文字 <input type="text" @change="config.type = 'index'" v-model="config.character"
			  :class="{error: config.error}" /> + 添字 </label>
	  </li>
	</ul>
      </li>
      <li>
	入力の形式
	<ul>
	  <li>
	    <label for="eqn"><input type="radio" v-model="config.show" value="eqn" id="eqn" /> 連立方程式 </label>
	  </li>
	  <li>
	    <label for="matrix"><input type="radio" v-model="config.show" value="matrix" id="matrix" /> 行列表示 </label>
	  </li>
	  <li>
	    <label for="aug"><input type="radio" v-model="config.show" value="aug" id="aug" /> 拡大係数行列 </label>
	  </li>
	</ul>
      </li>
    </ul>
    <p v-if="calc == 'inverse' || calc == 'det'">
      <input type="text" :class="{error: rows_error}" v-model.number="rows_i" />次正方行列
    </p>
      
    <h3> {{ calc == 'eqn' ? '係数' : '成分'}} </h3>
      <p>計算できるのは有理数のみです。文字式や無理数、虚数は扱えません。分数は「-1/2」のように入力して下さい。</p>
      <p>
	<button @click="random">ランダムに生成</button>
	<button @click="clearMatrix">消去</button>
      </p>
      <div class="math">
	<table class="matrix">
	  <tr>
	    <td class="leftp" :rowspan="rows+2"></td>
	    <td class="dummy" :rowspan="rows+2"></td>
	    <td :colspan="config.show == 'matrix' ? cols-1 : config.show == 'aug' ? cols+1 : cols"></td>
	    <td class="dummy" :rowspan="rows+2"></td>
	    <td v-if="config.show != 'eqn'" class="rightp" :rowspan="rows+2"></td>
	  </tr>
	  <tr v-for="(row,i) of original" :key="'r'+i">
	    <template v-for="(e,j) of row" >
	      <td v-if="config.show == 'aug' && j == cols-1" :key="'aug'+i + '_' + j"> | </td>
	      <td v-if="j < cols-1 || config.show != 'matrix'" :key="'c'+i + '_' + j">
		<span v-if="config.show == 'eqn' && j>0"> {{ j == cols-1 ? '=' : '+' }} </span>
		<input type="text" :class="{error: original[i][j].error}" v-model="original[i][j].input"/>
		<Variable v-if="config.show == 'eqn' && j<cols-1" :config="config" :index="j"></Variable>
	      </td>
	    </template>
	  </tr>
	  <tr>
	    <td :colspan="config.show == 'matrix' ? cols-1 : cols"></td>
	  </tr>
	</table>
	<template v-if="config.show == 'matrix'">
	  <table class="matrix">
	    <tr>
	      <td class="leftp" :rowspan="cols+1"></td>
	      <td class="dummy" :rowspan="cols+1"></td>
	      <td class="dummy"></td>
	      <td class="dummy" :rowspan="cols+1"></td>
	      <td class="rightp" :rowspan="cols+1"></td>
	    </tr>
	    <tr v-for="j in cols-1" :key="'r'+(j-1)">
	      <td><Variable :config="config" :index="j-1"></Variable></td>
	    </tr>
	    <tr>
	      <td class="dummy"></td>
	    </tr>
	  </table>
	  =
	  <table class="matrix">
	    <tr>
	      <td class="leftp" :rowspan="rows+2"></td>
	      <td class="dummy" :rowspan="rows+2"></td>
	      <td class="dummy"></td>
	      <td class="dummy" :rowspan="rows+2"></td>
	      <td v-if="config.show != 'eqn'" class="rightp" :rowspan="rows+2"></td>
	    </tr>
	    <tr v-for="(row,i) of original" :key="'r'+i">
	      <td><input type="text" :class="{error: original[i][cols-1].error}" v-model="original[i][cols-1].input"/></td>
	    </tr>
	    <tr>
	      <td class="dummy"></td>
	    </tr>
	  </table>
	</template>
      </div>
      <p v-if="! error">
	<button class="exec" @click="setMatrix">決定</button>
	<span class="bar">|</span>
	<button v-if="calc=='reduce'" @click="link('Equations')">この行列を拡大係数行列とする連立方程式</button>
	<button v-if="calc=='reduce' && rows == cols" @click="link('Inverse')">逆行列</button>
	<button v-if="calc=='reduce' && rows == cols" @click="link('Determinant')">行列式</button>
	<button v-if="calc=='eqn'" @click="link('Reduction')">拡大係数行列の簡約化</button>
	<button v-if="calc=='eqn' && rows == cols-1" @click="link('Inverse')">係数行列の逆行列</button>
	<button v-if="calc=='eqn' && rows == cols-1" @click="link('Determinant')">係数行列の行列式</button>
	<button v-if="calc=='inverse'" @click="link('Reduction')">この行列の簡約化</button>
	<button v-if="calc=='inverse'" @click="link('Equations')">この行列を係数行列とする連立方程式</button>
	<button v-if="calc=='inverse'" @click="link('Determinant')">行列式</button>
	<button v-if="calc=='det'" @click="link('Reduction')">この行列の簡約化</button>
	<button v-if="calc=='det'" @click="link('Equations')">この行列を係数行列とする連立方程式</button>
	<button v-if="calc=='det'" @click="link('Inverse')">逆行列</button>	
      </p>
  </section>
</template>

<script>
import { InputField } from '@/lib/base.js';
import Variable from '@/components/Variable.vue'

export default {
  name: 'InputMatrix',
  components: {
    Variable
  },
  props: {
    calc: String, // reduce, eqn, inverse, det
    original: Array,
    config: Object,
    keep: Boolean,
  },
  data: function(){
    return {
      rows_i: 3,
      cols_i: 3,
      rows_error: false,
      cols_error: false
    }
  },
  computed: {
    error(){
      return this.rows_error || this.cols_error || this.config.error || this.original.some( r => r.some( e => e.error ));
    },
    rows(){
      return this.original.length;
    },
    cols(){
      return this.original.length == 0 ? 0 : this.original[0].length;
    }  
  },
  created: function(){
    this.setSize();
  },
  methods: {
    setSize(){
      this.rows_error = ! Number.isInteger(this.rows_i) || this.rows_i <= 1 || this.rows_i > 10;
      this.cols_error = (this.calc == 'reduce' || this.calc == 'eqn') &&
	(! Number.isInteger(this.cols_i) || this.cols_i < 1 || this.cols_i > 10);
      if(this.rows_error || this.cols_error){
	return;
      }
      const rows = this.rows_i;
      const cols = (this.calc == 'reduce') ? this.cols_i :
	(this.calc == 'eqn') ? this.cols_i + 1 : rows;
      if(this.original.length > rows){
	this.original.splice(rows);
      }
      for(let i=this.original.length; i<rows;i++){
	this.original.push([]);
      }
      for(const r of this.original){
	if(r.length > cols){
	  r.splice(cols);
	}
	for(let j = r.length; j<cols; j++){
	  r.push(new InputField(''));
	}
      }
    },
    clearMatrix(){
      for(const r of this.original){
	for(const e of r){
	  e.input = '';
	}
      }
    },
    random(){
      for(const r of this.original){
	for(const e of r){
	  e.input = '' + Math.floor(Math.random()*20-9);
	}
      }
    },
    setMatrix(){
      if(this.eroor){
	return;
      }
      this.$emit('finish');
    },
    link(name){
      this.$router.push({ name: name, params: { keep: true } });
    }
  },
  watch: {
    rows_i: function(){
      this.setSize();
    },
    cols_i: function(){
      this.setSize();
    },
    calc: function(to,from){
      this.rows_i = this.original.length;
      if(this.rows_i > 0){
	if(to == 'reduce'){
	  this.cols_i = this.original[0].length;
	}else if(to == 'eqn'){
	  if(from == 'det' || from == 'inverse'){
	    this.cols_i = this.rows_i;
	  }else{ // from == 'reduce'
	    this.cols_i = this.original[0].length-1;
	  }
	}else{ // to == 'det' || 'inverse'
	  this.cols_i = 3;
	}
      }else{
	this.rows_i = 3;
	this.cols_i = 3;
      }
      this.setSize();
      if(! this.keep){
	this.clearMatrix();
      }
    }
  }
}
</script>

<style scoped>
.bar {
    margin-left: 25px;
    margin-right: 25px;
}
</style>
